import * as React from 'react';
import { FinancialsInfo } from './FinancialsInfo';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';

interface MatterFinancialsInfoCardProps {
    title: string;
    id: string;
    sourceSystem: string;
    isInternalUser: boolean;
}

// tslint:disable-next-line:no-any
export class RvMatterFinancialsInfoCard extends React.Component<MatterFinancialsInfoCardProps, {}>  {

    render() {
        return (
            // tslint:disable-next-line: no-any */}
            <Query<any> query={localCurrency} fetchPolicy="cache-first">
                {({loading, error, data }) => {
                    const lCurrency = ( loading || error ) ? null : data.options.localCurrency;

                    const currency = lCurrency ? lCurrency.currency : null;

                    const homeCountry = ( loading || error ) ? 'AU' : data.options.homeCountry.stringValue;

                    return (
                        <FinancialsInfo 
                            id={this.props.id} 
                            currencySymbol={currency}
                            sourceSystem={this.props.sourceSystem}
                            isInternalUser={this.props.isInternalUser} 
                            homeCountry={homeCountry}
                        />
                    );
                }}
            </Query>
        );
    }
}

const localCurrency = gql`
    query localCurrency {
        options {
            localCurrency {
                currency
            }
            homeCountry {
                stringValue
            }
        }
    }
`;